import { env } from '@/env'
import Echo from 'laravel-echo'
import { useLayoutStore } from '@/pinia/layout/useLayoutStore'
const { notification } = useLayoutStore()
//namespace: 'App.Domains.ProjectManagement.Events',
//namespace: 'App.Domains.ExternalIntegration.Events',

// chanel integrations

export function updateTaskEventCallback(response: any) {
  notification('success', `${response.message} Текущий статус - "${response.task.status.title}"`)
}

export function initWebsocket(namespace?: string) {
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: env.VUE_APP_SOCKET_URL,
    authEndpoint: `${env.VUE_APP_SERVER}/broadcasting/auth`,
    auth: {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    },
  })
}

export function addChanel(chanelName: string, eventName: string, callback: any) {
  window.Echo.channel(chanelName).listen(eventName, callback)
}

export function addPrivateChanel(chanelName: string, eventName: string, callback: any) {
  window.Echo.private(chanelName).listen(eventName, callback)
}

export function deleteListener(chanelName?: string, callback?: () => any) {
  // user.value.teams.forEach((team: any) => window.Echo.private('App.Team.' + team.id).stopListening('NotifyTeamEvent'))
  // window.Echo.leaveChannel('NotifyTeamEvent')
  window.Echo.disconnect()
}

// this.echoWithNamespace = new Echo({
//   broadcaster: 'socket.io',
//   host: process.env.VUE_APP_SOCKET_URL,
//   authEndpoint: `${process.env.VUE_APP_BACKEND}/broadcasting/authorization`,
//   namespace: 'App.Domains.ExternalIntegration.Events',
//   authorization: {
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//       Authorization: 'Bearer ' + localStorage.getItem('token'),
//     },
//   },
// })
